module.exports = __webpack_public_path__ + "static/img/1.54b90bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/1.png
// module id = kKD9
// module chunks = 0